interface ChatButtonProps {
  onClick: () => void;
  label?: string;
  /** Play the one-time attention wiggle and (if `cta` is set) show the tooltip. */
  nudge?: boolean;
  /** Call-to-action text for the tooltip shown alongside the wiggle. */
  cta?: string;
  /** Dismiss the tooltip without opening the chat (the tooltip's close button). */
  onDismissCta?: () => void;
}

export function ChatButton({
  onClick,
  label = "Chat with us",
  nudge = false,
  cta,
  onDismissCta,
}: ChatButtonProps) {
  return (
    <>
      {nudge && cta && (
        <div class="nx-cta">
          {/* The bubble body opens the chat; the corner button just dismisses. */}
          <button class="nx-cta__open" type="button" onClick={onClick}>
            {cta}
          </button>
          <button
            class="nx-cta__close"
            type="button"
            aria-label="Dismiss"
            onClick={(e) => {
              e.stopPropagation();
              onDismissCta?.();
            }}
          >
            <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M6 6l12 12M18 6L6 18"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
      )}
      <button
        class={`nx-launcher${nudge ? " nx-launcher--wiggle" : ""}`}
        type="button"
        onClick={onClick}
        aria-label={label}
      >
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M4 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H9l-4 4v-4H6a2 2 0 0 1-2-2V6Z"
            stroke="currentColor"
            stroke-width="2"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </>
  );
}
